import { IconButton } from "@mui/material"

const LightBlueIconButton = ({ onClick, children }) => {
  return (
    <IconButton
      size="small"
      sx={{
        backgroundColor: "#E0EBFF", // Use theme primary color
        color: "primary.main", // Icon color
        borderRadius: "16px",
        width: 58,
        height: 58,

        "&:hover": {
          backgroundColor: "#E0EBFF", // Darker shade on hover
        },
      }}
      onClick={onClick}
    >
      {children}
    </IconButton>
  )
}

export default LightBlueIconButton
